module.exports = __webpack_public_path__ + "static/media/clinician-rhythm-video-thumbnail.d79902e9.png";